/**
 * Claude Agent SDK 的 SDKMessage 子集（`sdk.message` 事件的 payload 原样透传，protocol 不约束形状）。
 * 这里只声明 UI 需要读取的字段；未知类型一律忽略。
 */

export interface TextBlock {
  type: "text";
  text: string;
}
export interface ThinkingBlock {
  type: "thinking";
  thinking: string;
}
export interface ToolUseBlock {
  type: "tool_use";
  id: string;
  name: string;
  input: Record<string, unknown>;
}
export interface ToolResultBlock {
  type: "tool_result";
  tool_use_id: string;
  content: string | { type: "text"; text: string }[];
  is_error?: boolean;
}
export type ContentBlock = TextBlock | ThinkingBlock | ToolUseBlock | ToolResultBlock;

export interface SdkAssistant {
  type: "assistant";
  uuid?: string;
  message: { id: string; content: ContentBlock[] };
}
export interface SdkUser {
  type: "user";
  uuid?: string;
  message: { content: string | ContentBlock[] };
}
export interface SdkStreamEvent {
  type: "stream_event";
  event:
    | { type: "message_start"; message: { id: string } }
    | { type: "content_block_start"; index: number; content_block: ContentBlock }
    | {
        type: "content_block_delta";
        index: number;
        delta: { type: "text_delta"; text: string } | { type: "thinking_delta"; thinking: string } | { type: "input_json_delta"; partial_json: string };
      }
    | { type: "content_block_stop"; index: number }
    | { type: "message_stop" };
}
export interface SdkResult {
  type: "result";
  subtype: string;
  total_cost_usd?: number;
  is_error?: boolean;
}
export interface SdkSystem {
  type: "system";
  subtype: string;
  model?: string;
}
export type SdkMessage = SdkAssistant | SdkUser | SdkStreamEvent | SdkResult | SdkSystem;

export function isSdkMessage(x: unknown): x is SdkMessage {
  return !!x && typeof x === "object" && typeof (x as { type?: unknown }).type === "string";
}

export function toolResultText(c: ToolResultBlock["content"]): string {
  return typeof c === "string" ? c : c.map((x) => x.text).join("");
}
